import { createReducer, createActions } from 'reduxsauce'
import {
  initialFeedback,
  requestFeedback,
  successFeedback,
  failureFeedback,
} from 'reducers/utils'

/**
 * Asistente del Asesor: metricas de citas (spec 006) y encuesta de
 * satisfaccion del lead (spec 010, Story 2).
 *
 * `metrics: null` distingue "todavia no se pidio / fallo" de "el periodo vino
 * en ceros". La UI necesita esa diferencia para no dibujar un dashboard de
 * ceros cuando en realidad el backend no contesto.
 */
const INITIAL_STATE = {
  metrics: null,
  feedback: initialFeedback(),
  survey: {
    metrics: null,
    feedback: initialFeedback(),
  },
  comments: {
    items: [],
    total: 0,
    page: 1,
    feedback: initialFeedback(),
  },
}

const { Types, Creators } = createActions(
  {
    getMetricsRequest: ['params'],
    getMetricsSuccess: ['metrics'],
    getMetricsFailure: ['errors'],

    getSurveyMetricsRequest: ['params'],
    getSurveyMetricsSuccess: ['metrics'],
    getSurveyMetricsFailure: ['errors'],

    getSurveyCommentsRequest: ['params'],
    getSurveyCommentsSuccess: ['comments'],
    getSurveyCommentsFailure: ['errors'],

    cleanState: [],
  },
  { prefix: 'ADVISOR_ASSISTANT_' },
)

const getMetricsRequest = state => ({
  ...state,
  feedback: requestFeedback(),
})

const getMetricsSuccess = (state, { metrics }) => ({
  ...state,
  metrics,
  feedback: successFeedback(),
})

const getMetricsFailure = (state, { errors }) => ({
  ...state,
  metrics: null,
  feedback: failureFeedback(errors),
})

const getSurveyMetricsRequest = state => ({
  ...state,
  survey: { ...state.survey, feedback: requestFeedback() },
})

const getSurveyMetricsSuccess = (state, { metrics }) => ({
  ...state,
  survey: { metrics, feedback: successFeedback() },
})

const getSurveyMetricsFailure = (state, { errors }) => ({
  ...state,
  survey: { metrics: null, feedback: failureFeedback(errors) },
})

const getSurveyCommentsRequest = state => ({
  ...state,
  comments: { ...state.comments, feedback: requestFeedback() },
})

const getSurveyCommentsSuccess = (state, { comments }) => ({
  ...state,
  comments: {
    items: comments.items,
    total: comments.total,
    page: comments.page,
    feedback: successFeedback(),
  },
})

const getSurveyCommentsFailure = (state, { errors }) => ({
  ...state,
  comments: {
    ...INITIAL_STATE.comments,
    feedback: failureFeedback(errors),
  },
})

const cleanState = () => INITIAL_STATE

const HANDLERS = {
  [Types.GET_METRICS_REQUEST]: getMetricsRequest,
  [Types.GET_METRICS_SUCCESS]: getMetricsSuccess,
  [Types.GET_METRICS_FAILURE]: getMetricsFailure,

  [Types.GET_SURVEY_METRICS_REQUEST]: getSurveyMetricsRequest,
  [Types.GET_SURVEY_METRICS_SUCCESS]: getSurveyMetricsSuccess,
  [Types.GET_SURVEY_METRICS_FAILURE]: getSurveyMetricsFailure,

  [Types.GET_SURVEY_COMMENTS_REQUEST]: getSurveyCommentsRequest,
  [Types.GET_SURVEY_COMMENTS_SUCCESS]: getSurveyCommentsSuccess,
  [Types.GET_SURVEY_COMMENTS_FAILURE]: getSurveyCommentsFailure,

  [Types.CLEAN_STATE]: cleanState,
}

export const AdvisorAssistantActionTypes = Types
export const AdvisorAssistantActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
